<template>
  <v-list>
    <v-list-item
      v-for="n in links"
      :key="n.to"
      :title="n.title"
      :prepend-icon="n.icon"
      :to="n.to"
    />
  </v-list>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data: function () {
    return {
      links: [
        {
          title: "Home",
          icon: "mdi-home",
          to: "/",
        },
        {
          title: "Patients",
          icon: "mdi-account-multiple-outline",
          to: "/patient",
        },
        {
          title: "Scripts",
          icon: "mdi-prescription",
          to: "/prescriptions",
        },

        {
          title: "Approve Scripts",
          icon: "mdi-file-document-check-outline",
          to: "/approval",
        },
        {
          title: "Clinic",
          icon: "mdi-hospital-building",
          to: "/clinics",
        },
        {
          title: "Profile",
          icon: "mdi-account",
          to: "/profile",
        },

        {
          title: "PBS Auth Test",
          icon: "mdi-speedometer",
          to: "/pbsauthtest",
        },        
      ],
    };
  },
});
</script>
